<vl-region v-if="organisationDetail">
    <vl-form-grid mod-stacked>
        <vl-column>
            <vl-title tag-name="h2">Openbaar domeinbeheerder</vl-title>
        </vl-column>
    </vl-form-grid>
    <kl-pda-zone-list :pdaZoneDetailRoute="routePdaZoneDetail" :organisationId="organisation.organisationId" :zones="pdaZones" :fetching="fetchingPdaZones" />
</vl-region>
